import { Category } from 'types/entity/category';

export const clearSpaces = (value: string) => value.split(' ').join('');

export const getEstimationPhrase = (days: number) => {
  const estimatedDeliveryDate = new Date();

  estimatedDeliveryDate.setDate(estimatedDeliveryDate.getDate() + days);

  const formattedEstimatedDeliveryDate = estimatedDeliveryDate.toLocaleDateString().replace(/\//g, '-');

  const estimationPhrase = `Est. ${formattedEstimatedDeliveryDate} to`;

  return estimationPhrase;
};

export const hasCustomQuoteCta = (categories?: Category[]) =>
  categories?.some((cat) => cat.categoryKey !== undefined && ['floating-stairs','flight-stairs'].includes(cat.categoryKey));
